export default [
  {
    path: '/meals/cookbook',
    translationKey: 'app.meals.mainScreen.categoryMenu.cookbookTab',
  },
  {
    path: '/meals/day-plan',
    translationKey: 'meals.mainScreen.categoryMenu.mealPlanTab',
  },
];
